import { render } from "./CategoriesPopUpFilterItemsScroll.vue?vue&type=template&id=2856f8d6&scoped=true"
import script from "./CategoriesPopUpFilterItemsScroll.vue?vue&type=script&lang=js"
export * from "./CategoriesPopUpFilterItemsScroll.vue?vue&type=script&lang=js"

import "./CategoriesPopUpFilterItemsScroll.vue?vue&type=style&index=0&id=2856f8d6&lang=scss&scoped=true"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2856f8d6"],['__file',"src/components/CategoriesPopUpFilterItemsScroll.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2856f8d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2856f8d6', __exports__)) {
    console.log('reload')
    api.reload('2856f8d6', __exports__)
  }
  
  module.hot.accept("./CategoriesPopUpFilterItemsScroll.vue?vue&type=template&id=2856f8d6&scoped=true", () => {
    console.log('re-render')
    api.rerender('2856f8d6', render)
  })

}


export default __exports__